import React from 'react';
import { GuidedRecipeShort } from 'data/Article/types';
import { ZapCardDetails } from '@zapier/design-system-patterns';
import { Button } from '@zapier/design-system';
import styled from '@emotion/styled';
import { OptionSelected, useAvroTracking } from 'tracking/avro';

const detailsButtonText = 'Details';
const tryItButtonText = 'Try it';

export const ZapTemplateDetails = ({
  template,
}: {
  template: GuidedRecipeShort;
}) => {
  const { emitCTAClickEvent } = useAvroTracking();
  return (
    <ZapCardDetails steps={[]}>
      <div data-testid="zap-template-details-description">
        {template.metaDescription}
      </div>
      <ButtonWrapper data-testid="zap-template-details-buttons">
        {template.url && (
          <Button
            target="_blank"
            href={template.url}
            color="secondary"
            onClick={() => {
              emitCTAClickEvent({
                destination_url_address: template.url!,
                interaction_raw_text: detailsButtonText,
                option_selected: OptionSelected.secondary_cta_button,
                custom_tracking_fields: {
                  template_id: template.id,
                  component: 'ZapTemplateDetails',
                },
              });
            }}
          >
            {detailsButtonText}
          </Button>
        )}
        <Button
          href={template.editorUrl}
          target="_blank"
          onClick={() => {
            emitCTAClickEvent({
              destination_url_address: template.editorUrl!,
              interaction_raw_text: tryItButtonText,
              option_selected: OptionSelected.cta_button,
              custom_tracking_fields: {
                component: 'ZapTemplateDetails',
                template_id: template.id,
              },
            });
          }}
        >
          {tryItButtonText}
        </Button>
      </ButtonWrapper>
    </ZapCardDetails>
  );
};

const ButtonWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  > * {
    margin: 0 5px !important;
  }
`;
